import assetReducer from './assetReducer'

export default assetReducer